import React from 'react';
import { genURL } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, } from '@mui/x-data-grid';
import { Box, Hidden } from '@mui/material';


export default function DepartmentList(props) {
    const [state, setState] = React.useState({
        loading: true,
        data: [],
        selectionModel: [],
        multiselect: true
    })

    React.useEffect(() => {
        getDataInDB();
        return () => {
        }
    }, [])


    React.useEffect(() => {
        setState({
            ...state,
            multiselect: props.multiselect
        })
        return () => {
        }
    }, [props.multiselect])

    const getDataInDB = async () => {
        let rows = []
        await setState({
            ...state,
            loading: true
        })
        let url = `CSDEPARTMENT/GetAll?`
        await axios.get(genURL(url)).then(e => {
            console.log(e)
            for (let index = 0; index < e.data.length; index++) {
                rows.push({ id: index + 1, code: e.data[index].CODE, name: e.data[index].MYNAMETH })
            }
        })
        //   await console.log(rows);
        await setState({
            ...state,
            loading: false,
            data: rows
        })
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hideable: false },
        {
            field: 'code',
            headerName: 'Department Code',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'Department Name',
            width: 150,
            editable: false,
            flex: 1
        },
    ];
    const handleDoubleClick = (e) => {
        let result = []
        if (state.selectionModel.length > 0) {
            result = state.data.filter((elem) => {
                return state.selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            result.push(e.row)
        }
        props.resultData(result)
    }
    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                }}
            >
                <GridToolbarQuickFilter />
            </Box>
        );
    }


    return (

        <>
            <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                {state.loading == true ? "กำลังโหลด..." :
                    <DataGrid
                        rows={state.data}
                        columns={columns}

                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector

                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            // filter: {
                            //     filterModel: {
                            //         items: [],
                            //         quickFilterValues: ['quick', 'filter'],
                            //     },
                            // },
                        }}
                        pageSizeOptions={[10]}

                        checkboxSelection={props.multiselect}
                        disableSelectionOnClick
                        onSelectionModelChange={(newSelectionModel) => {

                            setState({ ...state, selectionModel: newSelectionModel })
                        }}
                        selectionModel={state.selectionModel}
                        onRowDoubleClick={e => handleDoubleClick(e)}
                        //  onRowClick={e => handleClick(e)}
                        components={{ Toolbar: QuickSearchToolbar }}
                    />}
            </Box>
        </>
    )

}